import { CSSProperties } from 'react';
import { theme } from '../../theme';
import { isDesktop } from '../../platform';

export const giftCardPromoStyles = {
  // Figma 5789:23187: fondo #F5FAFF, 16 px arriba/abajo/izquierda, ícono de 25×24, 13 px de separación
  // y botón de 40×40 (sin padding derecho: el botón ya lo trae).
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: isDesktop ? theme.spacing.extraSmall : 13,
    padding: isDesktop ? `${theme.spacing.mediumSmall}px ${theme.spacing.medium}px` : `${theme.spacing.medium}px 0 ${theme.spacing.medium}px ${theme.spacing.medium}px`,
    backgroundColor: theme.colors.card.light,
    fontFamily: theme.typography.fontFamily,
    width: '100%',
    boxSizing: 'border-box',
  } as CSSProperties,

  icon: {
    width: 25,
    height: theme.spacing.large,
    minWidth: 25,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as CSSProperties,

  webIcon: {
    width: 32,
    height: 32,
    minWidth: 32,
  } as CSSProperties,

  content: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  } as CSSProperties,

  text: {
    fontSize: isDesktop ? theme.typography.fontSize.sm : theme.typography.fontSize.xs,
    fontWeight: theme.typography.fontWeight.normal,
    lineHeight: theme.typography.lineHeight.sm,
    color: theme.colors.label,
    fontFamily: theme.typography.fontFamily,
    margin: 0,
  } as CSSProperties,

  button: {
    width: 40,
    height: 40,
    minWidth: 40,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  } as CSSProperties,

  webButton: {
    backgroundColor: theme.colors.palette.blue100,
    borderRadius: theme.spacing.tiny,
    height: 30,
    minWidth: 30,
    width: 30,
  } as CSSProperties,
};
